import {
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Modal,
  Pagination,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha, typography } from "@mui/system";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableItem from "../../../components/TableItem";
import {
  getImportBillData,
  getImportBillById,
  searchImportItem,
} from "../../../services/Import";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Im_addBill from "./Im_addBill";
import { useHistory } from "react-router";
import InputField from "../../../FormComponents/InputField";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { RoleBasedRender } from "../../../components/RoleBaseRender";

// Custom styled components
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
}));

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius * 1.5,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(3),
  boxShadow: "0 8px 16px 0 rgba(0,0,0,0.1)",
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  textTransform: "none",
  fontWeight: 600,
  boxShadow: "0 4px 12px 0 rgba(0,0,0,0.1)",
}));

const FilterContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 1.5,
  backgroundColor: alpha(theme.palette.primary.light, 0.05),
  marginBottom: theme.spacing(3),
}));

const PaginationContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const statusChipConfig = {
  DRAFT: { label: "Draft", color: "warning" },
  AWAITING: { label: "Awaiting", color: "info" },
  APPROVED: { label: "Approved", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
};

let _imBillListState = null;

function Im_Bill() {
  const history = useHistory();
  const theme = useTheme();

  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openForm, setOpenForm] = React.useState(false);
  const [billLoading, set_billLoading] = React.useState(false);
  const [itemLoading, set_itemLoading] = React.useState(false);
  const [totalPages, setTotalPages] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (_imBillListState) {
      const { page: savedPage, filter: savedFilter } = _imBillListState;
      _imBillListState = null;
      setPage(savedPage);
      setFilter(savedFilter);
      fetchData(savedPage, savedFilter);
    } else {
      fetchData(0);
    }
  }, []);

  //get bill data
  const fetchData = async (pageNumber = 0, filterOverride = null) => {
    //get import Categories data when page loading...
    set_billLoading(true);
    const activeFilter = filterOverride ?? filter;
    let result = await getImportBillData(pageNumber, rowsPerPage, activeFilter);
    console.log(result);
    let billSet = result.content;

    //set total rows and pages
    setTotalPages(result.totalPages);
    setTotalRows(result?.totalElements || billSet?.length || 0);

    const newSet = [];
    if (billSet?.length != 0) {
      for (let x = 0; x < billSet?.length; x++) {
        let splitDate = billSet[x].createdDate.split("T");

        const cfg = statusChipConfig[billSet[x].status] || { label: billSet[x].status || "—", color: "default" };
        newSet.push(
          createDataForBills(
            billSet[x].billNo,
            billSet[x].addedBy,
            splitDate[0],
            billSet[x].shop,
            <Chip label={cfg.label} color={cfg.color} size="small" variant="outlined" />,
            billSet[x].bill_id
          )
        );
      }
    }
    set_billLoading(false);

    // set rows to table
    setRows(newSet);
  };

  //creating data for rows according to Id
  function createDataForBills(bill_num, added_by, date, shop, status, action) {
    return { bill_num, added_by, date, shop, status, action };
  }

  //columns for table
  const columns_bill = [
    { id: "bill_num", label: "Bill No.", minWidth: 100 },
    { id: "added_by", label: "Added By", minWidth: 100 },
    { id: "date", label: "Date", minWidth: 100 },
    { id: "shop", label: "Shop", minWidth: 100 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "action", label: "Actions", minWidth: 100 },
  ];

  //Drop down list for table
  const popUpList = [
    { id: 1, label: "View Items" },
    { id: 2, label: "Edit" },
    { id: 3, label: "Delete" },
  ];

  const handleChange = async (event, value) => {
    setPage(value - 1);
    await fetchData(value - 1);
  };

  // filter values
  const [filter, setFilter] = useState({
    _productCode: "",
    _itemName: "",
    _shop: "",
    _addedBy: "",
    _billNo: "",
  });

  //reset filters
  const resetFilters = () => {
    const emptyFilter = {
      _productCode: "",
      _itemName: "",
      _shop: "",
      _addedBy: "",
      _billNo: "",
    };
    setFilter(emptyFilter);
    setPage(0);
    fetchData(0, emptyFilter);
  };

  //to handle changing filters
  const handleFilterChange = (name, val) => {
    setFilter({
      ...filter,
      [name]: val,
    });
  };

  // Toggle filter visibility
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleAction = (event, id) => {
    console.log(event);
    switch (event) {
      case "view":
        _imBillListState = { page, filter };
        history.push("/template/im_bill_view/" + id);
        break;
      case "edit":
        history.push("/template/im_bill_edit/" + id);
        break;
      case "delete":
        return "bar";
      case "return":
        history.push("/template/im_bill_return/" + id);
        break;
      default:
        return "foo";
    }
  };

  return (
    <StyledPaper elevation={0}>
      {openForm ? (
        <Im_addBill setOpenForm={setOpenForm} />
      ) : (
        <>
          <HeaderCard>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <ReceiptIcon fontSize="large" />
              </Grid>
              <Grid item xs>
                <Typography variant="h5" fontWeight="bold">
                  Import Bill Management
                </Typography>
                <Typography variant="body2">
                  View and manage import bills
                </Typography>
              </Grid>
              <Grid item>
                <RoleBasedRender
                  allowedRoles={["IMPORT_BILL_CREATE", "ROLE_ADMIN"]}
                >
                  <ActionButton
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setOpenForm(true)}
                  >
                    Add Bill
                  </ActionButton>
                </RoleBasedRender>
              </Grid>
            </Grid>
          </HeaderCard>

          <Box
            mb={3}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TextField
              placeholder="Search by bill Number name..."
              variant="outlined"
              size="small"
              sx={{ width: "40%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                const newFilter = { ...filter, _billNo: e.target.value };
                handleFilterChange("_billNo", e.target.value);
                if (e.target.value.length > 2 || e.target.value.length === 0) {
                  setPage(0);
                  fetchData(0, newFilter);
                }
              }}
            />
            <Stack direction="row" spacing={2}>
              <Tooltip title="Toggle Filters">
                <ActionButton
                  variant="outlined"
                  color="primary"
                  startIcon={<FilterListIcon />}
                  onClick={toggleFilters}
                >
                  Filters
                </ActionButton>
              </Tooltip>
              <Chip
                label={`${totalRows} Categories`}
                variant="outlined"
                color="primary"
              />
            </Stack>
          </Box>

          {showFilters && (
            <FilterContainer>
              <Typography variant="subtitle2" fontWeight="bold" mb={2}>
                Advanced Filters
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <InputField
                    name="_productCode"
                    value={filter._productCode}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Product Code"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputField
                    name="_itemName"
                    value={filter._itemName}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Item Name"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputField
                    name="_shop"
                    value={filter._shop}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Shop"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputField
                    name="_addedBy"
                    value={filter._addedBy}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Added By"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputField
                    name="_billNo"
                    value={filter._billNo}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Bill Number"
                  />
                </Grid>
              </Grid>
              <Box mt={2} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Tooltip title="Reset Filters">
                    <ActionButton
                      variant="outlined"
                      color="secondary"
                      startIcon={<RestartAltIcon />}
                      onClick={resetFilters}
                    >
                      Reset
                    </ActionButton>
                  </Tooltip>
                  <Tooltip title="Apply Filters">
                    <ActionButton
                      variant="contained"
                      color="primary"
                      onClick={() => { setPage(0); fetchData(0, filter); }}
                    >
                      Apply Filters
                    </ActionButton>
                  </Tooltip>
                </Stack>
              </Box>
            </FilterContainer>
          )}

          <Divider sx={{ my: 2 }} />

          {billLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          ) : rows.length === 0 ? (
            <Box sx={{ textAlign: "center", p: 5 }}>
              <Typography variant="body1" color="textSecondary">
                No import bill found.
              </Typography>
            </Box>
          ) : (
            <TableItem
              setRow={null}
              dropDown={false}
              columns={columns_bill}
              rows={rows}
              handleAction={handleAction}
              showActions={{
                view: "Bill view",
                edit: "Bill edit",
                return: "Return items",
              }}
              actionRoles={{
                view: ["IMPORT_BILL_VIEW", "ROLE_ADMIN"],
                edit: ["IMPORT_BILL_UPDATE", "ROLE_ADMIN"],
                return: ["IMPORT_BILL_RETURN_CREATE", "ROLE_ADMIN"],
              }}
            />
          )}
          {totalPages > 1 && (
            <PaginationContainer>
              <Pagination
                count={totalPages}
                page={page + 1}
                variant="outlined"
                shape="rounded"
                color="primary"
                onChange={handleChange}
                size="medium"
              />
            </PaginationContainer>
          )}
        </>
      )}
    </StyledPaper>
  );
}

export default Im_Bill;
